import { analytics } from 'utils';

export interface SponsoredBrandGAEventData {
  searchQuery: string;
  contentId: string;
}

const sponsoredBrandTracker = (() => {
  const showSet = new Set<string>();
  const clickSet = new Set<string>();

  return {
    hasShown(contentId: string): boolean {
      return showSet.has(contentId);
    },
    markAsShown(contentId: string): void {
      showSet.add(contentId);
    },
    hasClicked(contentId: string): boolean {
      return clickSet.has(contentId);
    },
    markAsClicked(contentId: string): void {
      clickSet.add(contentId);
    },
  };
})();

export const sendSponsoredBrandShow = ({ searchQuery, contentId }: SponsoredBrandGAEventData) => {
  if (!contentId) return;

  if (!sponsoredBrandTracker.hasShown(contentId)) {
    analytics.sendEvent('GA:show', {
      elementType: 'block',
      elementBlock: 'headerSearch',
      elementName: 'searchBrand',
      elementText: null,
      eventVariant: searchQuery,
    });
    sponsoredBrandTracker.markAsShown(contentId);
  }
};

export const sendSponsoredBrandClick = ({ searchQuery, contentId }: SponsoredBrandGAEventData) => {
  if (!contentId) return;

  if (!sponsoredBrandTracker.hasClicked(contentId)) {
    analytics.sendEvent('GA:clickButton', {
      elementType: 'block',
      elementBlock: 'headerSearch',
      elementName: 'searchBrand',
      elementText: null,
      eventVariant: searchQuery,
    });
    sponsoredBrandTracker.markAsClicked(contentId);
  }
};
